import { Injectable, signal } from '@angular/core';

/**
 * A lightweight service that holds the current authentication headers.
 * This service acts as a mediator to break circular dependencies between
 * AuthenticationService (injects NGXLogger) and AuthenticatedLoggerServerService (needs AuthenticationService).
 */
@Injectable({
  providedIn: 'root',
})
export class AuthHeadersService {
  readonly authHeaders = signal<Map<string, string> | undefined>(undefined);
}
